import {customElement, property, query} from 'lit/decorators.js';
import {FlywheelComponent} from '@gl/lit/lib/component.js';
import {ImmutableComponent} from '@gl/lit/components/mixins/immutable_component/index.js';
import type {Constructor} from '@gl/lit/types/classes.js';
import type {Model} from './architecture.js';
import {Msg, main} from './architecture.js';
import type FlyModal from '@gl/lit/components/base/modal/index.js';

import styles from './style.scss';

export const CONFIRM_MODAL_ELEMENT_TAG = 'fly-confirm-modal';

/**
 * FlyConfirmModal
 * A popup modal for user risky-actions, like delete, which requires confirmation.
 *
 * @fires modal:confirm
 * @fires modal:cancel
 * @fires modal:open
 * @fires modal:close
 *
 */
@customElement(CONFIRM_MODAL_ELEMENT_TAG)
export default class FlyConfirmModal extends ImmutableComponent<
  Constructor<FlywheelComponent>,
  Model,
  Msg
>({component: FlywheelComponent, main}) {
  static get styles() {
    return [styles];
  }

  @property({type: Boolean, reflect: true})
  get open() {
    return this.model.open;
  }
  set open(value: boolean) {
    this.handleUpdate(value ? Msg.open() : Msg.close());
  }

  @property({type: Boolean, reflect: true})
  closeOnConfirm = false;

  @property({type: String, reflect: true, attribute: 'confirm-intent'})
  confirmIntent = 'danger';

  @property({type: String, reflect: true, attribute: 'cancel-intent'})
  cancelIntent = 'secondary';

  @property({type: String, reflect: true, attribute: 'icon'})
  icon = 'error';

  @property({type: String, reflect: true, attribute: 'icon-fill'})
  iconFill = 'red';

  @property({type: String, reflect: true, attribute: 'icon-size'})
  iconSize = '2xl';

  @property({type: String, reflect: true, attribute: 'confirm-variant'})
  confirmVariant = 'outlined';

  @property({type: String, reflect: true, attribute: 'cancel-variant'})
  cancelVariant = 'outlined';

  @property({type: String, reflect: true, attribute: 'message-intent'})
  messageIntent = 'danger';

  @query('fly-modal', true)
  $flyModal?: FlyModal;
}

declare global {
  interface HTMLElementTagNameMap {
    [CONFIRM_MODAL_ELEMENT_TAG]: FlyConfirmModal;
  }
}
